import dayjs from "dayjs";

export const getNbDays = (startDate: string, endDate: string) => {
  return dayjs(endDate).diff(dayjs(startDate), "d", true);
};
